import { render } from "./CheckBoxSmall.vue?vue&type=template&id=4dc188b1&scoped=true&ts=true"
import script from "./CheckBoxSmall.vue?vue&type=script&lang=ts"
export * from "./CheckBoxSmall.vue?vue&type=script&lang=ts"

import "./CheckBoxSmall.vue?vue&type=style&index=0&id=4dc188b1&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc188b1"]])

export default __exports__